Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var container = {
    zIndex: 1
  };
  var heading = {
    marginBottom: spacing.l,
    textAlign: 'center'
  };
  var filterContainer = {
    marginTop: spacing.xxl,
    zIndex: 1
  };
  var chart = {
    alignSelf: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    heading: heading,
    filterContainer: filterContainer,
    chart: chart
  });
  return {
    styles: styles
  };
};